module.exports = __webpack_public_path__ + "static/full05-8b9a743e46575caa373bcdef3b14ae94.png";